import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DialogService } from 'primeng/dynamicdialog';
import { Subject, Subscription, takeUntil } from 'rxjs';
import { GetStockItems$Params } from 'src/api/generated/fn/inventory/get-stock-items';
import { GetMenuCategoriesForVenue$Params } from 'src/api/generated/fn/menu-v-2/get-menu-categories-for-venue';
import { GetMenuItem$Params } from 'src/api/generated/fn/menu-v-2/get-menu-item';
import { GetMenuSubcategoriesByMenuCategoryId$Params } from 'src/api/generated/fn/menu-v-2/get-menu-subcategories-by-menu-category-id';
import { GetTaxRates$Params } from 'src/api/generated/fn/tax-rate-v-2/get-tax-rates';
import { MenuCategoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/MenuCategories/menu-category-dto';
import { MenuItemIngredientDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/MenuItemIngredients/menu-item-ingredient-dto';
import { MenuItemDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/MenuItems/menu-item-dto';
import { MenuSubcategoryDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/MenuSubcategories/menu-subcategory-dto';
import { StockItemDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/StockItem/stock-item-dto';
import { TaxRateV2Dto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/TaxRatesV2/tax-rate-v-2-dto';
import { InventoryService, MenuV2Service, TaxRateV2Service } from 'src/api/generated/services';
import { MeasurementUnit } from 'src/app/pos-panel/enums/measurement-unit.enum';
import { InventoryStockLineItemDto } from 'src/app/pos-panel/models/inventory/inventory-stock-line-item.model';
import { AuthenticationService } from 'src/app/share-modul/services/authentication/authentication.service';
import { CurrentVenueHelperService } from 'src/app/share-modul/services/current-venue-helper/current-venue.helper.service';
import { AddOrEditInventoryItemComponent } from '../../../inventory-management/add-or-edit-inventory-item/add-or-edit-inventory-item.component';
import { MenuCurrencyDto } from 'src/api/generated/models/Digiwork/MaitreD/Pos/DTO/Menu/menu-currency-dto';
import { CurrencyService } from 'src/app/pos-panel/services/currency-helper/currency.service';

@Component({
  selector: 'app-add-or-edit-menu-item',
  templateUrl: './add-or-edit-menu-item.component.html',
  styleUrls: ['./add-or-edit-menu-item.component.scss']
})
export class AddOrEditMenuItemComponentV2 implements OnInit, OnDestroy {

  form: FormGroup;
  unsubscribe: Subject<void> = new Subject<void>();
  pictureFormat: Array<string>;
  imageFile: any;
  imageName: any;
  imageSize: any;
  imagePath: any = './assets/images/img-menu-item-image-placeholder.png';
  stockItemsList: Array<StockItemDto> = new Array<StockItemDto>();
  menuItem: MenuItemDto = {} as MenuItemDto;
  taxRates: Array<TaxRateV2Dto> = new Array<TaxRateV2Dto>();
  categories: Array<MenuCategoryDto> = new Array<MenuCategoryDto>();
  subcategories: Array<MenuSubcategoryDto> = new Array<MenuSubcategoryDto>();
  venueId: string;
  editFlag: boolean = false;
  menuItemId: string;
  venueIdUpdateSubscription: Subscription;
  currency: MenuCurrencyDto;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private currentVenueHelper: CurrentVenueHelperService,
    private inventoryService: InventoryService,
    private taxRateService: TaxRateV2Service,
    private authService: AuthenticationService,
    private menuV2Service: MenuV2Service,
    public currencyService: CurrencyService,
    public dialogService: DialogService,
    private messageService: MessageService,
    private formBuilder: FormBuilder,
  ) {
    this.route.params.subscribe(params => {
      if (params['venue-id'] != null) {
        this.venueId = params['venue-id'];
        this.currentVenueHelper.updateCurrentVenueIdDropdown(params['venue-id']);
      }
      if (params['menu-item-id'] != null) {
        this.menuItemId = params['menu-item-id'];
        this.editFlag = true;
      }
    });
    this.currencyService.currencyObservable().subscribe(currency => this.currency = currency);
    if(!this.editFlag){
      this.createForm();
    } else {
      this.form = this.formBuilder.group({
        name: new FormControl('', {
          validators: [Validators.required]
        }),
        category: new FormControl('', {
          validators: [Validators.required]
        }),
        subcategory: new FormControl('', {
          validators: []
        }),
        price: new FormControl('', {
          validators: [Validators.required]
        }),
        taxRate: new FormControl('', {
          validators: [Validators.required]
        }),
        ingredients: this.formBuilder.array([
        ])
      });   
    }

    this.menuItem.taxRate = {} as TaxRateV2Dto;
    this.menuItem.menuItemIngredients = new Array<InventoryStockLineItemDto>()

    this.getStockItems();

    this.getTaxRates();

    this.getMenuCategoriesForVenue();

    this.pictureFormat = ['image/png', 'image/jpg', 'image/jpeg'];
  }

  ngOnInit(): void {

  }

  addMenuItem(imageFile: any) {
    if(this.form.valid){
    const formInfo = this.form.getRawValue();
    let params: any = {
      body: {
        Name: formInfo.name,
        ImageFile: imageFile,
        MenuCategoryId: formInfo.category ? formInfo.category.id : undefined,
        MenuSubcategoryId: formInfo.subcategory ? formInfo.subcategory.id : undefined,
        Price: formInfo.price ? formInfo.price : undefined,
        TaxRateId: formInfo.taxRate ? formInfo.taxRate.id : undefined,
        ItemIngredients: this.ingredients.getRawValue(),
      }
    };
    params.body.ItemIngredients = JSON.stringify(params.body.ItemIngredients)
    this.menuV2Service.addMenuItem(params)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.router.navigate([this.venueId, "menuV2"], { queryParams: { activeIndex: 1 } });
        },
        error: errorResponse => {
        }
      });
    }
  }

  cancel() {
    this.router.navigate([this.venueId, "menuV2"], { queryParams: { activeIndex: 1 } });
  }

  addNewRow(): void {
    this.ingredients.push(this.createTableRow());
  }

  onDeleteRow(index: number) {
    this.ingredients.removeAt(index);
  }

  addNewStockItem() {
    const ref = this.dialogService.open(AddOrEditInventoryItemComponent, {
      width: '372px',
      showHeader: false
    });
    ref.onClose.subscribe((response: any) => {
      if (response) {
        this.messageService.add({ severity: 'success', summary: 'Item was successfully added!', life: 3000 });
        this.getStockItems()
      } else if (response == false) {
        this.messageService.add({ severity: 'error', summary: 'Error occurred!', life: 3000 });
      }
    });
  }
  getStockItems() {
    const stockItemsParams: GetStockItems$Params = { isRemoved: false };
    this.inventoryService.getStockItems(stockItemsParams).subscribe(response => this.stockItemsList = response.stockItems ? response.stockItems : []);
  }

  getTaxRates() {
    const taxRatesParams: GetTaxRates$Params = { companyId: this.authService.getCompanyId(), isRemoved: false };
    this.taxRateService.getTaxRates(taxRatesParams).subscribe(response => this.taxRates = response.taxRates ? response.taxRates : []);
  }

  onSelectFile(event: any): void {
    const files = event.target.files;
    if (files.length === 0)
      return;
    if (!this.pictureFormat.includes(event.target.files[0].type))
      return;

    const reader = new FileReader();
    this.imageFile = files[0];
    this.imageName = files[0].name;
    this.imageSize = (files[0].size / 1024).toFixed(2) + "KB";
    reader.readAsDataURL(files[0]);
    reader.onload = (_event) => {
      this.imagePath = reader.result;
    }
  }

  onChangeCategory(category?: MenuCategoryDto) {
    const menuCategory = this.form.controls['category'].value;
    const menuCategoryId = category ? category.id : (menuCategory ? menuCategory.id : '');    
    const menuSubcategoriesParams: GetMenuSubcategoriesByMenuCategoryId$Params = { menuCategoryId: menuCategoryId, isRemoved: false };
    this.menuV2Service.getMenuSubcategoriesByMenuCategoryId(menuSubcategoriesParams).subscribe(response => this.subcategories = response.menuSubcategories ? response.menuSubcategories : []);
  }
  
  getMenuCategoriesForVenue() {
    var params: GetMenuCategoriesForVenue$Params = {} as GetMenuCategoriesForVenue$Params;
    params.venueId = this.venueId;
    params.isRemoved = false;
    params.isMenuSubcategoryRemoved = false;
    this.menuV2Service.getMenuCategoriesForVenue(params)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          if (response.menuCategories) {
            this.categories = response.menuCategories;
            if (this.editFlag) {
              this.getMenuItem();
            }
          }
        },
        error: errorResponse => {
        }
      });
  }

  getMenuItem() {
    var params: GetMenuItem$Params = {} as GetMenuItem$Params;
    params.menuItemId = this.menuItemId;
    this.menuV2Service.getMenuItem(params)
      .pipe(takeUntil(this.unsubscribe))
      .subscribe({
        next: (response) => {
          this.menuItem = response;
          this.menuItem.menuCategory = this.categories.find(x => x.id == response.menuCategory?.id)
          this.onChangeCategory(this.menuItem.menuCategory);
          this.editForm(this.menuItem);
        },
        error: errorResponse => {
        }
      });
  }

  editMenuItem(imageFile: any) {
    if(this.form.valid){
      const formInfo = this.form.getRawValue();

      let params: any = {
        menuItemId: this.menuItemId,
        body: {
          Name: formInfo.name,
          ImageFile: imageFile,
          MenuCategoryId: formInfo.category ? formInfo.category.id : undefined,
          MenuSubcategoryId: formInfo.subcategory ? formInfo.subcategory.id : undefined,
          Price: formInfo.price ? formInfo.price : undefined,
          TaxRateId: formInfo.taxRate ? formInfo.taxRate.id : undefined,
          ItemIngredients: this.ingredients.getRawValue().length != 0 ? this.ingredients.getRawValue() : undefined,
        }
      };
      params.body.ItemIngredients = JSON.stringify(params.body.ItemIngredients)
      this.menuV2Service.updateMenuItem_1(params)
        .pipe(takeUntil(this.unsubscribe))
        .subscribe({
          next: (response) => {
            this.router.navigate([this.venueId, "menuV2"], { queryParams: { activeIndex: 1 } });
          },
          error: errorResponse => {
          }
        });
    }

  }

  setQuantityinfo(unitType: string){
    if(unitType == MeasurementUnit.Kilogram){
      return 'kg'
    }
     if(unitType == MeasurementUnit.Liter){
      return 'L'
    }
    if(unitType == MeasurementUnit.Pieces){
      return 'pc'
    }
    return '-';
  }

  private createForm(): void {
      this.form = this.formBuilder.group({
        name: new FormControl('', {
          validators: [Validators.required]
        }),
        category: new FormControl('', {
          validators: []
        }),
        subcategory: new FormControl('', {
          validators: []
        }),
        price: new FormControl('', {
          validators: []
        }),
        taxRate: new FormControl('', {
          validators: []
        }),
        ingredients: this.formBuilder.array([
        ])
      });   
  }

  private editForm(item: MenuItemDto): void {
    var ingr: Array<any> = new Array<any>();
    item.menuItemIngredients?.forEach(i => ingr.push(this.createEditableTableRow(i)));

    this.form = this.formBuilder.group({
      name: new FormControl(item.name , {
        validators: [Validators.required]
      }),
      category: new FormControl(item.menuCategory, {
        validators: []
      }),
      subcategory: new FormControl(item.menuSubcategory, {
        validators: []
      }),
      price: new FormControl(item.price, {
        validators: []
      }),
      taxRate: new FormControl(item.taxRate, {
        validators: []
      }),
      ingredients: this.formBuilder.array(ingr)
    });   
}

  private createTableRow(): FormGroup {
    return this.formBuilder.group({
      stockItem: new FormControl('', {
        validators: [Validators.required]
      }),
      quantity: new FormControl('', {
        validators: [Validators.required]
      })
    });
  }

  private createEditableTableRow(ingr: MenuItemIngredientDto): FormGroup {
    return this.formBuilder.group({
      stockItem: new FormControl(ingr.stockItem, {
        validators: [Validators.required]
      }),
      quantity: new FormControl(ingr.quantity, {
        validators: [Validators.required]
      })
    });
  }

  addNewRowValidation(): void {
    this.ingredients.push(this.createTableRow());
  }

  get ingredients(): FormArray {
    return this.form.get('ingredients') as FormArray;
  }

  getIngredientControls(index: number){
    return (this.ingredients.controls[index] as FormGroup)
  }

  onDeleteRowValidation(rowIndex: number): void {
    this.ingredients.removeAt(rowIndex);
  }
  public ngOnDestroy(): void {
    if (this.venueIdUpdateSubscription) {
      this.venueIdUpdateSubscription.unsubscribe();
    }
  }
}

